// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-in-panel__portal-root-overlay{
    width: 100%;
    min-width: 100vw;
    height: 100%;
    min-height: 100vh;
    background-color: var(--app-background-overlay);
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 209;
}
.slide-in-panel{
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    min-width: 280px;
    z-index: 210;
    width: fit-content;
    box-shadow: -1px 1px 3px 0 rgba(0, 0, 0, 0.2);
    background-color: var(--app-primary-bg-color-white);
    overflow: auto;
}
@media screen and (min-width: 320px) {
    .slide-in-panel{
        min-width: 320px;
    }
}

.slide-in-panel__header{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 110;
    background-color: var(--app-primary-bg-color-white);
}
.slide-in-panel__header{
    padding: calc(env(safe-area-inset-top, 0) + 2.0625rem) 1rem 1rem;
}
.slide-in-panel__content{
    padding: 10px 1rem 2rem;
}
.slide-in-panel__content {
    padding-bottom: 100px;
}

@media screen and (min-width:  680px){
    .slide-in-panel__header{
        padding: 2.0625rem 3rem 1rem;
    }
    .slide-in-panel__content{
        padding: 10px 3rem 2rem;
    }
    .slide-in-panel{
        min-width: 472px;
        max-width: 545px;
    }

}
.slide-in-panel__header-text{
    font-size: 21px;
    margin: 0;
    font-weight: 600;
    word-break: break-all;
}
.slide-in-panel__header-close-button-icon{
    width: 1rem;
    height: auto;
}

#slide-in-panel__portal-root--showHiddenMenu-nav-bar-hidden-menu .slide-in-panel{
    z-index: 200;
}
#slide-in-panel__portal-root--showHiddenMenu-nav-bar-hidden-menu .slide-in-panel__portal-root-overlay{
    z-index: 199;
}
`, "",{"version":3,"sources":["webpack://./src/core/components/SlidePanel/styles/SlidePanel.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,+CAA+C;IAC/C,eAAe;IACf,QAAQ;IACR,MAAM;IACN,SAAS;IACT,OAAO;IACP,YAAY;AAChB;AACA;IACI,eAAe;IACf,QAAQ;IACR,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,6CAA6C;IAC7C,mDAAmD;IACnD,cAAc;AAClB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,mDAAmD;AACvD;AACA;IACI,gEAAgE;AACpE;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;AAEJ;AACA;IACI,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB","sourcesContent":[".slide-in-panel__portal-root-overlay{\n    width: 100%;\n    min-width: 100vw;\n    height: 100%;\n    min-height: 100vh;\n    background-color: var(--app-background-overlay);\n    position: fixed;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 209;\n}\n.slide-in-panel{\n    position: fixed;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    min-width: 280px;\n    z-index: 210;\n    width: fit-content;\n    box-shadow: -1px 1px 3px 0 rgba(0, 0, 0, 0.2);\n    background-color: var(--app-primary-bg-color-white);\n    overflow: auto;\n}\n@media screen and (min-width: 320px) {\n    .slide-in-panel{\n        min-width: 320px;\n    }\n}\n\n.slide-in-panel__header{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    position: sticky;\n    top: 0;\n    z-index: 110;\n    background-color: var(--app-primary-bg-color-white);\n}\n.slide-in-panel__header{\n    padding: calc(env(safe-area-inset-top, 0) + 2.0625rem) 1rem 1rem;\n}\n.slide-in-panel__content{\n    padding: 10px 1rem 2rem;\n}\n.slide-in-panel__content {\n    padding-bottom: 100px;\n}\n\n@media screen and (min-width:  680px){\n    .slide-in-panel__header{\n        padding: 2.0625rem 3rem 1rem;\n    }\n    .slide-in-panel__content{\n        padding: 10px 3rem 2rem;\n    }\n    .slide-in-panel{\n        min-width: 472px;\n        max-width: 545px;\n    }\n\n}\n.slide-in-panel__header-text{\n    font-size: 21px;\n    margin: 0;\n    font-weight: 600;\n    word-break: break-all;\n}\n.slide-in-panel__header-close-button-icon{\n    width: 1rem;\n    height: auto;\n}\n\n#slide-in-panel__portal-root--showHiddenMenu-nav-bar-hidden-menu .slide-in-panel{\n    z-index: 200;\n}\n#slide-in-panel__portal-root--showHiddenMenu-nav-bar-hidden-menu .slide-in-panel__portal-root-overlay{\n    z-index: 199;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
